export class Factory {
    id: number;
    userId: string;
    name: string;
    history: string;
    mission: string;
    vision: string;
    logo: string;
    constructor(factory: any) {
      this.id = factory.id;
      this.mission = factory.mission;
      this.history = factory.history;
      this.name = factory.name;
      this.userId = factory.userId;
      this.logo = factory.logo;
      this.vision = factory.vision;
    }
  }

export class FactoryChild {
    id: number;
    phone: string;
    email: string;
    firstName: string;
    lastName: string;
    picturePath: string;
    businessName: string;
    title: string;
    type: number;
    status: number;
    registrationDate: number;
    constructor(currentUser: any) {
      this.id = currentUser.id;
      this.lastName = currentUser.lastName;
      this.firstName = currentUser.firstName;
      this.email = currentUser.email;
      this.phone = currentUser.phone;
      this.type = currentUser.type;
      this.title = currentUser.title;
      this.businessName = currentUser.businessName;
      this.picturePath = currentUser.picturePath;
      this.status = currentUser.status;
      this.registrationDate = currentUser.registrationDate;
    }
}
